'use client'

import React from 'react'
import { MacroProps } from './macro-props'
import { getCommaSeparatedStrings } from './macro-parameter-extractor'
import ProductListByIds from '@dustin-web/product-components/src/product-list-by-ids'

export const MultipleProductBoxes = (props: MacroProps) => {
  const productIds = getCommaSeparatedStrings('productids', props)

  return productIds ? (
    <ProductListByIds
      productErpIdentifiers={productIds}
      listType={'gallery'}
      digitalDataOrigin="contentMacro"
    />
  ) : null

  // TODO: Search phrase?
}

export default MultipleProductBoxes
